<template>
  <div class="whitebox flex-column align-items-center gap-16 p-3">
    <IllustrationsError />
    <span class="illustration-title error">{{ $t("bnpl:customer_limit.error.illustration_title") }}</span>
  </div>
</template>

<script setup>

</script>

<style scoped lang="scss">
.illustration-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 130%;

  &.error {
    color: var(--systemError);
  }
}
</style>
